import { atomFamily } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myTimesheetTabsState = atomFamily({
  key: "myTimesheetTabsState",
  default: 0,
  effects_UNSTABLE: [ocPersistAtom],
});

export default myTimesheetTabsState;
